var {
  useProviderProps,
  useProvider
} = require("@react-spectrum/provider");

var {
  useFilter,
  useMessageFormatter
} = require("@react-aria/i18n");

var {
  useField
} = require("@react-aria/label");

var {
  useDialog
} = require("@react-aria/dialog");

var {
  useComboBox
} = require("@react-aria/combobox");

var {
  useButton
} = require("@react-aria/button");

var {
  Tray,
  Popover
} = require("@react-spectrum/overlays");

var {
  TextFieldBase
} = require("@react-spectrum/textfield");

var {
  setInteractionModality,
  useHover,
  PressResponder
} = require("@react-aria/interactions");

var _react2 = require("react");

var _react = $parcel$interopDefault(_react2);

var {
  useCallback,
  useEffect,
  useRef,
  useState
} = _react2;

var {
  ProgressCircle
} = require("@react-spectrum/progress");

var {
  mergeProps,
  useId,
  useLayoutEffect
} = require("@react-aria/utils");

var {
  useComboBoxState
} = require("@react-stately/combobox");

var _spectrumIconsUiCheckmarkMedium = $parcel$interopDefault(require("@spectrum-icons/ui/CheckmarkMedium"));

var _spectrumIconsUiAlertMedium = $parcel$interopDefault(require("@spectrum-icons/ui/AlertMedium"));

var {
  ListBoxBase,
  useListBoxLayout
} = require("@react-spectrum/listbox");

var {
  FocusRing,
  FocusScope,
  focusSafely
} = require("@react-aria/focus");

var {
  FieldButton,
  ClearButton
} = require("@react-spectrum/button");

var {
  Field
} = require("@react-spectrum/label");

var {
  DismissButton,
  useOverlayPosition,
  useOverlayTrigger
} = require("@react-aria/overlays");

var {
  classNames,
  useFocusableRef,
  useIsMobileDevice,
  useResizeObserver,
  useUnwrapDOMRef,
  unwrapDOMRef
} = require("@react-spectrum/utils");

var _spectrumIconsUiChevronDownMedium = $parcel$interopDefault(require("@spectrum-icons/ui/ChevronDownMedium"));

var _babelRuntimeHelpersInteropRequireDefault = $parcel$interopDefault(require("@babel/runtime/helpers/interopRequireDefault"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

var {
  Item,
  Section
} = require("@react-stately/collections");

exports.Section = Section;
exports.Item = Item;

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/src/combobox.css
var $e7ba5e7d00617a260ea1fc3d7c6f84$exports = {};
$e7ba5e7d00617a260ea1fc3d7c6f84$exports = {
  "no-results": "_no-results_b1b77",
  "mobile-combobox": "_mobile-combobox_b1b77",
  "mobile-input": "_mobile-input_b1b77",
  "mobile-value": "_mobile-value_b1b77",
  "tray-dialog": "_tray-dialog_b1b77",
  "tray-textfield": "_tray-textfield_b1b77",
  "has-label": "_has-label_b1b77",
  "tray-textfield-input": "_tray-textfield-input_b1b77",
  "tray-listbox": "_tray-listbox_b1b77"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/button/vars.css
var $a9040831959d0ed42473e9713dd4b23$exports = {};
$a9040831959d0ed42473e9713dd4b23$exports = {
  "spectrum-Button": "_spectrum-Button_7a745",
  "spectrum-ActionButton": "_spectrum-ActionButton_7a745",
  "spectrum-LogicButton": "_spectrum-LogicButton_7a745",
  "spectrum-FieldButton": "_spectrum-FieldButton_7a745",
  "spectrum-ClearButton": "_spectrum-ClearButton_7a745",
  "focus-ring": "_focus-ring_7a745",
  "spectrum-Icon": "_spectrum-Icon_7a745",
  "spectrum-ActionButton--emphasized": "_spectrum-ActionButton--emphasized_7a745",
  "spectrum-ActionButton--staticColor": "_spectrum-ActionButton--staticColor_7a745",
  "is-hovered": "_is-hovered_7a745",
  "spectrum-Button-label": "_spectrum-Button-label_7a745",
  "spectrum-ActionButton-label": "_spectrum-ActionButton-label_7a745",
  "spectrum-ActionButton-hold": "_spectrum-ActionButton-hold_7a745",
  "spectrum-ActionButton--quiet": "_spectrum-ActionButton--quiet_7a745",
  "is-disabled": "_is-disabled_7a745",
  "is-open": "_is-open_7a745",
  "spectrum-FieldButton--quiet": "_spectrum-FieldButton--quiet_7a745",
  "spectrum-ClearButton--overBackground": "_spectrum-ClearButton--overBackground_7a745",
  "spectrum-ClearButton--small": "_spectrum-ClearButton--small_7a745",
  "is-focused": "_is-focused_7a745",
  "is-active": "_is-active_7a745",
  "spectrum-Button--cta": "_spectrum-Button--cta_7a745",
  "spectrum-Button--primary": "_spectrum-Button--primary_7a745",
  "spectrum-Button--secondary": "_spectrum-Button--secondary_7a745",
  "spectrum-Button--warning": "_spectrum-Button--warning_7a745",
  "spectrum-Button--overBackground": "_spectrum-Button--overBackground_7a745",
  "spectrum-Button--quiet": "_spectrum-Button--quiet_7a745",
  "is-selected": "_is-selected_7a745",
  "spectrum-ActionButton--staticWhite": "_spectrum-ActionButton--staticWhite_7a745",
  "spectrum-ActionButton--staticBlack": "_spectrum-ActionButton--staticBlack_7a745",
  "spectrum-LogicButton--and": "_spectrum-LogicButton--and_7a745",
  "spectrum-LogicButton--or": "_spectrum-LogicButton--or_7a745",
  "is-placeholder": "_is-placeholder_7a745",
  "spectrum-FieldButton--invalid": "_spectrum-FieldButton--invalid_7a745"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/ar-AE.json
var $d04863043a6dfd841a5fd044e8fb2$exports = {};
$d04863043a6dfd841a5fd044e8fb2$exports = JSON.parse("{\"clear\":\"مسح\",\"invalid\":\"(غير صالح)\",\"loading\":\"جارٍ التحميل...\",\"noResults\":\"لا توجد نتائج\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/bg-BG.json
var $b564d16583cfc267d10376ad5192e6$exports = {};
$b564d16583cfc267d10376ad5192e6$exports = JSON.parse("{\"clear\":\"Изчисти\",\"invalid\":\"(невалиден)\",\"loading\":\"Зареждане...\",\"noResults\":\"Няма резултати\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/cs-CZ.json
var $ca0d0f630aeba45c0ca219f116e$exports = {};
$ca0d0f630aeba45c0ca219f116e$exports = JSON.parse("{\"clear\":\"Vymazat\",\"invalid\":\"(neplatné)\",\"loading\":\"Načítání...\",\"noResults\":\"Žádné výsledky\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/da-DK.json
var $e006382483b74343bd65ed7b3e69a7e8$exports = {};
$e006382483b74343bd65ed7b3e69a7e8$exports = JSON.parse("{\"clear\":\"Ryd\",\"invalid\":\"(ugyldig)\",\"loading\":\"Indlæser ...\",\"noResults\":\"Ingen resultater\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/de-DE.json
var $e4919612465f407969e10964f4739e46$exports = {};
$e4919612465f407969e10964f4739e46$exports = JSON.parse("{\"clear\":\"Löschen\",\"invalid\":\"(ungültig)\",\"loading\":\"Wird geladen...\",\"noResults\":\"Keine Ergebnisse\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/el-GR.json
var $a80ba2012c6a01e9158d4476904ed27$exports = {};
$a80ba2012c6a01e9158d4476904ed27$exports = JSON.parse("{\"clear\":\"Καθαρισμός\",\"invalid\":\"(δεν ισχύει)\",\"loading\":\"Φόρτωση...\",\"noResults\":\"Χωρίς αποτέλεσμα\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/en-US.json
var $d0a979efa2a3d269e4805071429722$exports = {};
$d0a979efa2a3d269e4805071429722$exports = JSON.parse("{\"loading\":\"Loading...\",\"noResults\":\"No results\",\"clear\":\"Clear\",\"invalid\":\"(invalid)\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/es-ES.json
var $cd829ef0083d6ff19146cf99f43e121d$exports = {};
$cd829ef0083d6ff19146cf99f43e121d$exports = JSON.parse("{\"clear\":\"Borrar\",\"invalid\":\"(no válido)\",\"loading\":\"Cargando...\",\"noResults\":\"Sin resultados\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/et-EE.json
var $a1c2e0c1703ae90fb8380fae0c635aa$exports = {};
$a1c2e0c1703ae90fb8380fae0c635aa$exports = JSON.parse("{\"clear\":\"Puhasta\",\"invalid\":\"(kehtetu)\",\"loading\":\"Laadimine...\",\"noResults\":\"Tulemusi pole\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/fi-FI.json
var $f8e6dd7bd4de277a7a4df3eb6bbee$exports = {};
$f8e6dd7bd4de277a7a4df3eb6bbee$exports = JSON.parse("{\"clear\":\"Kirkas\",\"invalid\":\"(epäkelpo)\",\"loading\":\"Ladataan...\",\"noResults\":\"Ei tuloksia\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/fr-FR.json
var $d66beaedaa291d2a87e5799a0994$exports = {};
$d66beaedaa291d2a87e5799a0994$exports = JSON.parse("{\"clear\":\"Effacer\",\"invalid\":\"(non valide)\",\"loading\":\"Chargement en cours...\",\"noResults\":\"Aucun résultat\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/he-IL.json
var $c4e3e1ce888c68f1a497452feb58c471$exports = {};
$c4e3e1ce888c68f1a497452feb58c471$exports = JSON.parse("{\"clear\":\"נקי\",\"invalid\":\"(לא חוקי)\",\"loading\":\"טוען...\",\"noResults\":\"אין תוצאות\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/hr-HR.json
var $abc197c7249b5d64e5aa6e6cd9d70e04$exports = {};
$abc197c7249b5d64e5aa6e6cd9d70e04$exports = JSON.parse("{\"clear\":\"Izbriši\",\"invalid\":\"(nevažeće)\",\"loading\":\"Učitavam...\",\"noResults\":\"Nema rezultata\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/hu-HU.json
var $ace2570df1c8e5bdc1622423fba3afcb$exports = {};
$ace2570df1c8e5bdc1622423fba3afcb$exports = JSON.parse("{\"clear\":\"Törlés\",\"invalid\":\"(érvénytelen)\",\"loading\":\"Betöltés folyamatban…\",\"noResults\":\"Nincsenek találatok\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/it-IT.json
var $a3230a2547d18894783fda977dc20f9c$exports = {};
$a3230a2547d18894783fda977dc20f9c$exports = JSON.parse("{\"clear\":\"Cancella\",\"invalid\":\"(non valido)\",\"loading\":\"Caricamento in corso...\",\"noResults\":\"Nessun risultato\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/ja-JP.json
var $e4e9d17d054a5b1571e266c27b0$exports = {};
$e4e9d17d054a5b1571e266c27b0$exports = JSON.parse("{\"clear\":\"クリア\",\"invalid\":\"(無効)\",\"loading\":\"読み込み中...\",\"noResults\":\"結果なし\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/ko-KR.json
var $b759cad58197b50c1b0a70079b90d0$exports = {};
$b759cad58197b50c1b0a70079b90d0$exports = JSON.parse("{\"clear\":\"지우기\",\"invalid\":\"(유효하지 않음)\",\"loading\":\"로드 중...\",\"noResults\":\"결과 없음\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/lt-LT.json
var $e3c9619de0e391888b7af3687ae1ca$exports = {};
$e3c9619de0e391888b7af3687ae1ca$exports = JSON.parse("{\"clear\":\"Skaidrus\",\"invalid\":\"(netinkama)\",\"loading\":\"Įkeliama...\",\"noResults\":\"Be rezultatų\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/lv-LV.json
var $ffaa0058474a0c5af84ee42da22e89$exports = {};
$ffaa0058474a0c5af84ee42da22e89$exports = JSON.parse("{\"clear\":\"Notīrīt\",\"invalid\":\"(nederīgs)\",\"loading\":\"Notiek ielāde...\",\"noResults\":\"Nav rezultātu\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/nb-NO.json
var $eb97c66ca1aabe657d4d3d684a52745$exports = {};
$eb97c66ca1aabe657d4d3d684a52745$exports = JSON.parse("{\"clear\":\"Tøm\",\"invalid\":\"(ugyldig)\",\"loading\":\"Laster inn ...\",\"noResults\":\"Ingen resultater\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/nl-NL.json
var $df4355d3b8e7b4eb963b620181aa9fa$exports = {};
$df4355d3b8e7b4eb963b620181aa9fa$exports = JSON.parse("{\"clear\":\"Helder\",\"invalid\":\"(ongeldig)\",\"loading\":\"Laden...\",\"noResults\":\"Geen resultaten\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/pl-PL.json
var $a8b7f12ad4f258ed52f42c8a1cb43c55$exports = {};
$a8b7f12ad4f258ed52f42c8a1cb43c55$exports = JSON.parse("{\"clear\":\"Wyczyść\",\"invalid\":\"(nieprawidłowy)\",\"loading\":\"Trwa ładowanie...\",\"noResults\":\"Brak wyników\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/pt-BR.json
var $d4031e47e9461fd5df823a3a979d9c4$exports = {};
$d4031e47e9461fd5df823a3a979d9c4$exports = JSON.parse("{\"clear\":\"Limpar\",\"invalid\":\"(inválido)\",\"loading\":\"Carregando...\",\"noResults\":\"Nenhum resultado\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/pt-PT.json
var $ad26b7a6c8ce1c4b03972527c0ef2d02$exports = {};
$ad26b7a6c8ce1c4b03972527c0ef2d02$exports = JSON.parse("{\"clear\":\"Limpar\",\"invalid\":\"(inválido)\",\"loading\":\"A carregar...\",\"noResults\":\"Sem resultados\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/ro-RO.json
var $bba00e443e162220b2c6ec0ed425ca73$exports = {};
$bba00e443e162220b2c6ec0ed425ca73$exports = JSON.parse("{\"clear\":\"Golire\",\"invalid\":\"(nevalid)\",\"loading\":\"Se încarcă...\",\"noResults\":\"Niciun rezultat\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/ru-RU.json
var $edcd0095126ee31dc5d095f17da37f97$exports = {};
$edcd0095126ee31dc5d095f17da37f97$exports = JSON.parse("{\"clear\":\"Очистить\",\"invalid\":\"(недействительно)\",\"loading\":\"Загрузка...\",\"noResults\":\"Результаты отсутствуют\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/sk-SK.json
var $c466527fca88404b3f0ca88f196536d0$exports = {};
$c466527fca88404b3f0ca88f196536d0$exports = JSON.parse("{\"clear\":\"Vymazať\",\"invalid\":\"(neplatné)\",\"loading\":\"Načítava sa...\",\"noResults\":\"Žiadne výsledky\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/sl-SI.json
var $cb8c52ec91eb32b51c9ed7b52e7b8a23$exports = {};
$cb8c52ec91eb32b51c9ed7b52e7b8a23$exports = JSON.parse("{\"clear\":\"Jasen\",\"invalid\":\"(neveljavno)\",\"loading\":\"Nalaganje...\",\"noResults\":\"Ni rezultatov\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/sr-SP.json
var $d833d3e73b516f5452ebb1ad0ac66f2$exports = {};
$d833d3e73b516f5452ebb1ad0ac66f2$exports = JSON.parse("{\"clear\":\"Izbriši\",\"invalid\":\"(nevažeće)\",\"loading\":\"Učitavam...\",\"noResults\":\"Nema rezultata\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/sv-SE.json
var $d0b18d4d94ae04ae7e6849f6a9d3061$exports = {};
$d0b18d4d94ae04ae7e6849f6a9d3061$exports = JSON.parse("{\"clear\":\"Rensa\",\"invalid\":\"(ogiltigt)\",\"loading\":\"Läser in...\",\"noResults\":\"Inga resultat\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/tr-TR.json
var $c7f47492a7c0909c69e50b446c5fd9df$exports = {};
$c7f47492a7c0909c69e50b446c5fd9df$exports = JSON.parse("{\"clear\":\"Temizle\",\"invalid\":\"(geçersiz)\",\"loading\":\"Yükleniyor...\",\"noResults\":\"Sonuç yok\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/uk-UA.json
var $ba3d6fe17ecccf2b67f312467e19a2d$exports = {};
$ba3d6fe17ecccf2b67f312467e19a2d$exports = JSON.parse("{\"clear\":\"Очистити\",\"invalid\":\"(недійсне)\",\"loading\":\"Завантаження...\",\"noResults\":\"Результатів немає\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/zh-CN.json
var $b813e91f8ab3c16586a3f3286c12409e$exports = {};
$b813e91f8ab3c16586a3f3286c12409e$exports = JSON.parse("{\"clear\":\"透明\",\"invalid\":\"（无效）\",\"loading\":\"正在加载...\",\"noResults\":\"无结果\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/combobox/intl/zh-TW.json
var $f64529017d6a25dd65cf5b4903bb42a4$exports = {};
$f64529017d6a25dd65cf5b4903bb42a4$exports = JSON.parse("{\"clear\":\"清除\",\"invalid\":\"(無效)\",\"loading\":\"正在載入...\",\"noResults\":\"無任何結果\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldlabel/vars.css
var $a0bedb1888ff92cb3407d1a60d76e$exports = {};
$a0bedb1888ff92cb3407d1a60d76e$exports = {
  "spectrum-FieldLabel": "_spectrum-FieldLabel_36b9b",
  "spectrum-FieldLabel--positionSide": "_spectrum-FieldLabel--positionSide_36b9b",
  "spectrum-FieldLabel-requiredIcon": "_spectrum-FieldLabel-requiredIcon_36b9b",
  "spectrum-FieldLabel--alignEnd": "_spectrum-FieldLabel--alignEnd_36b9b",
  "spectrum-Field": "_spectrum-Field_36b9b",
  "spectrum-Field--positionTop": "_spectrum-Field--positionTop_36b9b",
  "spectrum-Field-field": "_spectrum-Field-field_36b9b",
  "spectrum-Field-field--multiline": "_spectrum-Field-field--multiline_36b9b",
  "spectrum-Field--positionSide": "_spectrum-Field--positionSide_36b9b",
  "spectrum-Field-wrapper": "_spectrum-Field-wrapper_36b9b",
  "spectrum-Form": "_spectrum-Form_36b9b",
  "spectrum-Form--positionSide": "_spectrum-Form--positionSide_36b9b",
  "spectrum-Form--positionTop": "_spectrum-Form--positionTop_36b9b",
  "spectrum-Form-itemLabel": "_spectrum-Form-itemLabel_36b9b",
  "is-disabled": "_is-disabled_36b9b"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/search/vars.css
var $b42ee6503342f63a10b70c33e73302b1$exports = {};
$b42ee6503342f63a10b70c33e73302b1$exports = {
  "spectrum-Search": "_spectrum-Search_d08c7",
  "spectrum-ClearButton": "_spectrum-ClearButton_d08c7",
  "is-quiet": "_is-quiet_d08c7",
  "spectrum-Search-input": "_spectrum-Search-input_d08c7",
  "spectrum-Search--invalid": "_spectrum-Search--invalid_d08c7",
  "spectrum-Search--valid": "_spectrum-Search--valid_d08c7",
  "spectrum-Search--loadable": "_spectrum-Search--loadable_d08c7",
  "spectrum-Search-circleLoader": "_spectrum-Search-circleLoader_d08c7",
  "spectrum-Search-validationIcon": "_spectrum-Search-validationIcon_d08c7",
  "spectrum-Textfield": "_spectrum-Textfield_d08c7"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/inputgroup/vars.css
var $da042374adac990dbdf960d689b813$exports = {};
$da042374adac990dbdf960d689b813$exports = {
  "spectrum-InputGroup": "_spectrum-InputGroup_d053e",
  "spectrum-FieldButton": "_spectrum-FieldButton_d053e",
  "is-disabled": "_is-disabled_d053e",
  "spectrum-InputGroup--invalid": "_spectrum-InputGroup--invalid_d053e",
  "spectrum-InputGroup--quiet": "_spectrum-InputGroup--quiet_d053e",
  "spectrum-InputGroup-field": "_spectrum-InputGroup-field_d053e",
  "spectrum-InputGroup-input-validationIcon": "_spectrum-InputGroup-input-validationIcon_d053e",
  "spectrum-InputGroup-input-circleLoader": "_spectrum-InputGroup-input-circleLoader_d053e",
  "spectrum-InputGroup-input": "_spectrum-InputGroup-input_d053e",
  "spectrum-InputGroup-icon": "_spectrum-InputGroup-icon_d053e",
  "spectrum-InputGroup-popover--quiet": "_spectrum-InputGroup-popover--quiet_d053e",
  "spectrum-Datepicker--range": "_spectrum-Datepicker--range_d053e",
  "spectrum-Datepicker--datetimeRange": "_spectrum-Datepicker--datetimeRange_d053e",
  "spectrum-Datepicker-startField": "_spectrum-Datepicker-startField_d053e",
  "spectrum-Datepicker-endField": "_spectrum-Datepicker-endField_d053e",
  "spectrum-Datepicker--rangeDash": "_spectrum-Datepicker--rangeDash_d053e",
  "is-focused": "_is-focused_d053e",
  "spectrum-Datepicker-focusRing": "_spectrum-Datepicker-focusRing_d053e",
  "is-hovered": "_is-hovered_d053e",
  "focus-ring": "_focus-ring_d053e",
  "is-selected": "_is-selected_d053e",
  "spectrum-FieldButton--invalid": "_spectrum-FieldButton--invalid_d053e"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/textfield/vars.css
var $d6ccebc39ce6c9807064e14b8824ec$exports = {};
$d6ccebc39ce6c9807064e14b8824ec$exports = {
  "spectrum-Textfield": "_spectrum-Textfield_61339",
  "spectrum-Textfield--quiet": "_spectrum-Textfield--quiet_61339",
  "spectrum-Textfield--multiline": "_spectrum-Textfield--multiline_61339",
  "spectrum-Textfield-input": "_spectrum-Textfield-input_61339",
  "is-placeholder": "_is-placeholder_61339",
  "is-hovered": "_is-hovered_61339",
  "spectrum-Textfield--valid": "_spectrum-Textfield--valid_61339",
  "spectrum-Textfield--invalid": "_spectrum-Textfield--invalid_61339",
  "spectrum-Textfield--loadable": "_spectrum-Textfield--loadable_61339",
  "spectrum-Textfield-validationIcon": "_spectrum-Textfield-validationIcon_61339",
  "spectrum-Textfield-icon": "_spectrum-Textfield-icon_61339",
  "spectrum-Textfield-inputIcon": "_spectrum-Textfield-inputIcon_61339",
  "spectrum-Textfield-circleLoader": "_spectrum-Textfield-circleLoader_61339",
  "is-focused": "_is-focused_61339",
  "focus-ring": "_focus-ring_61339",
  "is-disabled": "_is-disabled_61339"
};
// @ts-ignore
const $ba7df4b960ac8e701862298c225558$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($d04863043a6dfd841a5fd044e8fb2$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($b564d16583cfc267d10376ad5192e6$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($ca0d0f630aeba45c0ca219f116e$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($e006382483b74343bd65ed7b3e69a7e8$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($e4919612465f407969e10964f4739e46$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($a80ba2012c6a01e9158d4476904ed27$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($d0a979efa2a3d269e4805071429722$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($cd829ef0083d6ff19146cf99f43e121d$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($a1c2e0c1703ae90fb8380fae0c635aa$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($f8e6dd7bd4de277a7a4df3eb6bbee$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($d66beaedaa291d2a87e5799a0994$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($c4e3e1ce888c68f1a497452feb58c471$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($abc197c7249b5d64e5aa6e6cd9d70e04$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($ace2570df1c8e5bdc1622423fba3afcb$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($a3230a2547d18894783fda977dc20f9c$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($e4e9d17d054a5b1571e266c27b0$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($b759cad58197b50c1b0a70079b90d0$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($e3c9619de0e391888b7af3687ae1ca$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($ffaa0058474a0c5af84ee42da22e89$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($eb97c66ca1aabe657d4d3d684a52745$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($df4355d3b8e7b4eb963b620181aa9fa$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($a8b7f12ad4f258ed52f42c8a1cb43c55$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($d4031e47e9461fd5df823a3a979d9c4$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($ad26b7a6c8ce1c4b03972527c0ef2d02$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($bba00e443e162220b2c6ec0ed425ca73$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($edcd0095126ee31dc5d095f17da37f97$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($c466527fca88404b3f0ca88f196536d0$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($cb8c52ec91eb32b51c9ed7b52e7b8a23$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($d833d3e73b516f5452ebb1ad0ac66f2$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($d0b18d4d94ae04ae7e6849f6a9d3061$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($c7f47492a7c0909c69e50b446c5fd9df$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($ba3d6fe17ecccf2b67f312467e19a2d$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($b813e91f8ab3c16586a3f3286c12409e$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($f64529017d6a25dd65cf5b4903bb42a4$exports).default
};

const $ba7df4b960ac8e701862298c225558$export$MobileComboBox = /*#__PURE__*/_react.forwardRef(function MobileComboBox(props, ref) {
  props = useProviderProps(props);
  let {
    isQuiet,
    isDisabled,
    validationState,
    isReadOnly
  } = props;
  let {
    contains
  } = useFilter({
    sensitivity: 'base'
  });
  let state = useComboBoxState(_babelRuntimeHelpersExtends({}, props, {
    defaultFilter: contains,
    allowsEmptyCollection: true,
    // Needs to be false here otherwise we double up on commitSelection/commitCustomValue calls when
    // user taps on underlay (i.e. initial tap will call setFocused(false) -> commitSelection/commitCustomValue via onBlur,
    // then the closing of the tray will call setFocused(false) again due to cleanup effect)
    shouldCloseOnBlur: false
  }));
  let buttonRef = useRef();
  let domRef = useFocusableRef(ref, buttonRef);
  let {
    triggerProps,
    overlayProps
  } = useOverlayTrigger({
    type: 'listbox'
  }, state, buttonRef);
  let {
    labelProps,
    fieldProps
  } = useField(_babelRuntimeHelpersExtends({}, props, {
    labelElementType: 'span'
  })); // Focus the button and show focus ring when clicking on the label

  labelProps.onClick = () => {
    if (!props.isDisabled) {
      buttonRef.current.focus();
      setInteractionModality('keyboard');
    }
  };

  let onClose = () => state.commit();

  return /*#__PURE__*/_react.createElement(_react.Fragment, null, /*#__PURE__*/_react.createElement(Field, _babelRuntimeHelpersExtends({}, props, {
    labelProps: labelProps,
    elementType: "span",
    ref: domRef,
    includeNecessityIndicatorInAccessibilityName: true
  }), /*#__PURE__*/_react.createElement($ba7df4b960ac8e701862298c225558$var$ComboBoxButton, _babelRuntimeHelpersExtends({}, mergeProps(triggerProps, fieldProps, {
    autoFocus: props.autoFocus
  }), {
    ref: buttonRef,
    isQuiet: isQuiet,
    isDisabled: isDisabled,
    isPlaceholder: !state.inputValue,
    validationState: validationState,
    onPress: () => !isReadOnly && state.open(null, 'manual')
  }), state.inputValue || props.placeholder || '')), /*#__PURE__*/_react.createElement(Tray, _babelRuntimeHelpersExtends({
    isOpen: state.isOpen,
    onClose: onClose,
    isFixedHeight: true,
    isNonModal: true
  }, overlayProps), /*#__PURE__*/_react.createElement($ba7df4b960ac8e701862298c225558$var$ComboBoxTray, _babelRuntimeHelpersExtends({}, props, {
    onClose: onClose,
    overlayProps: overlayProps,
    state: state
  }))));
});

var $d6ccebc39ce6c9807064e14b8824ec$$interop$default = $parcel$interopDefault($d6ccebc39ce6c9807064e14b8824ec$exports);
var $da042374adac990dbdf960d689b813$$interop$default = $parcel$interopDefault($da042374adac990dbdf960d689b813$exports);
var $e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default = $parcel$interopDefault($e7ba5e7d00617a260ea1fc3d7c6f84$exports);
var $a0bedb1888ff92cb3407d1a60d76e$$interop$default = $parcel$interopDefault($a0bedb1888ff92cb3407d1a60d76e$exports);
var $a9040831959d0ed42473e9713dd4b23$$interop$default = $parcel$interopDefault($a9040831959d0ed42473e9713dd4b23$exports);

const $ba7df4b960ac8e701862298c225558$var$ComboBoxButton = /*#__PURE__*/_react.forwardRef(function ComboBoxButton(props, ref) {
  let {
    isQuiet,
    isDisabled,
    isPlaceholder,
    validationState,
    children,
    style,
    className
  } = props;
  let formatMessage = useMessageFormatter($ba7df4b960ac8e701862298c225558$var$intlMessages);
  let valueId = useId();
  let invalidId = useId();
  let validationIcon = validationState === 'invalid' ? /*#__PURE__*/_react.createElement(_spectrumIconsUiAlertMedium, {
    id: invalidId,
    "aria-label": formatMessage('invalid')
  }) : /*#__PURE__*/_react.createElement(_spectrumIconsUiCheckmarkMedium, null);

  let validation = /*#__PURE__*/_react.cloneElement(validationIcon, {
    UNSAFE_className: classNames($d6ccebc39ce6c9807064e14b8824ec$$interop$default, 'spectrum-Textfield-validationIcon', classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-input-validationIcon'))
  });

  let {
    hoverProps,
    isHovered
  } = useHover({});
  let {
    buttonProps,
    isPressed
  } = useButton(_babelRuntimeHelpersExtends({}, props, {
    'aria-labelledby': [props['aria-labelledby'], props['aria-label'] && !props['aria-labelledby'] ? props.id : null, valueId, validationState === 'invalid' ? invalidId : null].filter(Boolean).join(' '),
    elementType: 'div'
  }), ref);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusClass: classNames($da042374adac990dbdf960d689b813$$interop$default, 'is-focused'),
    focusRingClass: classNames($da042374adac990dbdf960d689b813$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, mergeProps(hoverProps, buttonProps), {
    "aria-haspopup": "dialog",
    ref: ref,
    style: _babelRuntimeHelpersExtends({}, style, {
      outline: 'none'
    }),
    className: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup', {
      'spectrum-InputGroup--quiet': isQuiet,
      'is-disabled': isDisabled,
      'spectrum-InputGroup--invalid': validationState === 'invalid',
      'is-hovered': isHovered
    }, classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'mobile-combobox'), className)
  }), /*#__PURE__*/_react.createElement("div", {
    className: classNames($d6ccebc39ce6c9807064e14b8824ec$$interop$default, 'spectrum-Textfield', {
      'spectrum-Textfield--invalid': validationState === 'invalid',
      'spectrum-Textfield--valid': validationState === 'valid',
      'spectrum-Textfield--quiet': isQuiet
    }, classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-field'))
  }, /*#__PURE__*/_react.createElement("div", {
    className: classNames($d6ccebc39ce6c9807064e14b8824ec$$interop$default, 'spectrum-Textfield-input', {
      'is-hovered': isHovered,
      'is-placeholder': isPlaceholder,
      'is-disabled': isDisabled
    }, classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-input', classNames($a0bedb1888ff92cb3407d1a60d76e$$interop$default, 'spectrum-Field-field')), classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'mobile-input'))
  }, /*#__PURE__*/_react.createElement("span", {
    id: valueId,
    className: classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'mobile-value')
  }, children)), validationState ? validation : null), /*#__PURE__*/_react.createElement("div", {
    className: classNames($a9040831959d0ed42473e9713dd4b23$$interop$default, 'spectrum-FieldButton', {
      'spectrum-FieldButton--quiet': isQuiet,
      'is-active': isPressed,
      'is-disabled': isDisabled,
      'spectrum-FieldButton--invalid': validationState === 'invalid',
      'is-hovered': isHovered
    }, classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-FieldButton'))
  }, /*#__PURE__*/_react.createElement(_spectrumIconsUiChevronDownMedium, {
    UNSAFE_className: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-Dropdown-chevron')
  }))));
});

var $b42ee6503342f63a10b70c33e73302b1$$interop$default = $parcel$interopDefault($b42ee6503342f63a10b70c33e73302b1$exports);

function $ba7df4b960ac8e701862298c225558$var$ComboBoxTray(props) {
  let {
    // completionMode = 'suggest',
    state,
    isDisabled,
    validationState,
    label,
    overlayProps,
    loadingState,
    onLoadMore,
    onClose
  } = props;
  let timeout = useRef(null);
  let [showLoading, setShowLoading] = useState(false);
  let inputRef = useRef();
  let buttonRef = useRef();
  let popoverRef = useRef();
  let listBoxRef = useRef();
  let layout = useListBoxLayout(state);
  let formatMessage = useMessageFormatter($ba7df4b960ac8e701862298c225558$var$intlMessages);
  let {
    inputProps,
    listBoxProps,
    labelProps
  } = useComboBox(_babelRuntimeHelpersExtends({}, props, {
    // completionMode,
    keyboardDelegate: layout,
    buttonRef: unwrapDOMRef(buttonRef),
    popoverRef: popoverRef,
    listBoxRef,
    inputRef
  }), state);

  _react.useEffect(() => {
    focusSafely(inputRef.current); // When the tray unmounts, set state.isFocused (i.e. the tray input's focus tracker) to false.
    // This is to prevent state.isFocused from being set to true when the tray closes via tapping on the underlay
    // (FocusScope attempts to restore focus to the tray input when tapping outside the tray due to "contain")
    // Have to do this manually since React doesn't call onBlur when a component is unmounted: https://github.com/facebook/react/issues/12363

    return () => {
      state.setFocused(false);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let {
    dialogProps
  } = useDialog({
    'aria-labelledby': useId(labelProps.id)
  }, popoverRef); // Override the role of the input to "searchbox" instead of "combobox".
  // Since the listbox is always visible, the combobox role doesn't really give us anything.
  // VoiceOver on iOS reads "double tap to collapse" when focused on the input rather than
  // "double tap to edit text", as with a textbox or searchbox. We'd like double tapping to
  // open the virtual keyboard rather than closing the tray.

  inputProps.role = 'searchbox';
  inputProps['aria-haspopup'] = 'listbox';
  delete inputProps.onTouchEnd;

  let clearButton = /*#__PURE__*/_react.createElement(ClearButton, {
    preventFocus: true,
    "aria-label": formatMessage('clear'),
    excludeFromTabOrder: true,
    onPress: () => {
      state.setInputValue('');
      inputRef.current.focus();
    },
    UNSAFE_className: classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-ClearButton'),
    isDisabled: isDisabled
  });

  let loadingCircle = /*#__PURE__*/_react.createElement(ProgressCircle, {
    "aria-label": formatMessage('loading'),
    size: "S",
    isIndeterminate: true,
    UNSAFE_className: classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-Search-circleLoader', classNames($d6ccebc39ce6c9807064e14b8824ec$$interop$default, 'spectrum-Textfield-circleLoader'))
  }); // Close the software keyboard on scroll to give the user a bigger area to scroll.
  // But only do this if scrolling with touch, otherwise it can cause issues with touch
  // screen readers.


  let isTouchDown = useRef(false);

  let onTouchStart = () => {
    isTouchDown.current = true;
  };

  let onTouchEnd = () => {
    isTouchDown.current = false;
  };

  let onScroll = useCallback(() => {
    if (!inputRef.current || document.activeElement !== inputRef.current || !isTouchDown.current) {
      return;
    }

    popoverRef.current.focus();
  }, [inputRef, popoverRef, isTouchDown]);
  let inputValue = inputProps.value;
  let lastInputValue = useRef(inputValue);
  useEffect(() => {
    if (loadingState === 'filtering' && !showLoading) {
      if (timeout.current === null) {
        timeout.current = setTimeout(() => {
          setShowLoading(true);
        }, 500);
      } // If user is typing, clear the timer and restart since it is a new request


      if (inputValue !== lastInputValue.current) {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
          setShowLoading(true);
        }, 500);
      }
    } else if (loadingState !== 'filtering') {
      // If loading is no longer happening, clear any timers and hide the loading circle
      setShowLoading(false);
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    lastInputValue.current = inputValue;
  }, [loadingState, inputValue, showLoading]);

  let onKeyDown = e => {
    // Close virtual keyboard if user hits Enter w/o any focused options
    if (e.key === 'Enter' && state.selectionManager.focusedKey == null) {
      popoverRef.current.focus();
    } else {
      inputProps.onKeyDown(e);
    }
  };

  return /*#__PURE__*/_react.createElement(FocusScope, {
    restoreFocus: true,
    contain: true
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, mergeProps(overlayProps, dialogProps), {
    ref: popoverRef,
    className: classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'tray-dialog')
  }), /*#__PURE__*/_react.createElement(DismissButton, {
    onDismiss: onClose
  }), /*#__PURE__*/_react.createElement(TextFieldBase, {
    label: label,
    labelProps: labelProps,
    inputProps: _babelRuntimeHelpersExtends({}, inputProps, {
      onKeyDown
    }),
    inputRef: inputRef,
    isDisabled: isDisabled,
    isLoading: showLoading && loadingState === 'filtering',
    loadingIndicator: loadingState != null && loadingCircle,
    validationState: validationState,
    wrapperChildren: (state.inputValue !== '' || loadingState === 'filtering' || validationState != null) && !props.isReadOnly && clearButton,
    UNSAFE_className: classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-Search', 'spectrum-Textfield', 'spectrum-Search--loadable', {
      'spectrum-Search--invalid': validationState === 'invalid',
      'spectrum-Search--valid': validationState === 'valid'
    }, classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'tray-textfield', {
      'has-label': !!props.label
    })),
    inputClassName: classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'tray-textfield-input', classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-Search-input')),
    validationIconClassName: classNames($b42ee6503342f63a10b70c33e73302b1$$interop$default, 'spectrum-Search-validationIcon')
  }), /*#__PURE__*/_react.createElement(ListBoxBase, _babelRuntimeHelpersExtends({}, listBoxProps, {
    domProps: {
      onTouchStart,
      onTouchEnd
    },
    disallowEmptySelection: true,
    shouldSelectOnPressUp: true,
    focusOnPointerEnter: true,
    layout: layout,
    state: state,
    shouldUseVirtualFocus: true,
    renderEmptyState: () => loadingState !== 'loading' && /*#__PURE__*/_react.createElement("span", {
      className: classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'no-results')
    }, formatMessage('noResults')),
    UNSAFE_className: classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'tray-listbox'),
    ref: listBoxRef,
    onScroll: onScroll,
    onLoadMore: onLoadMore,
    isLoading: loadingState === 'loading' || loadingState === 'loadingMore'
  })), /*#__PURE__*/_react.createElement(DismissButton, {
    onDismiss: onClose
  })));
}

// @ts-ignore
const $d9a9ec54ac1006cb2dd080cc05ab18c$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($d04863043a6dfd841a5fd044e8fb2$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($b564d16583cfc267d10376ad5192e6$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($ca0d0f630aeba45c0ca219f116e$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($e006382483b74343bd65ed7b3e69a7e8$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($e4919612465f407969e10964f4739e46$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($a80ba2012c6a01e9158d4476904ed27$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($d0a979efa2a3d269e4805071429722$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($cd829ef0083d6ff19146cf99f43e121d$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($a1c2e0c1703ae90fb8380fae0c635aa$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($f8e6dd7bd4de277a7a4df3eb6bbee$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($d66beaedaa291d2a87e5799a0994$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($c4e3e1ce888c68f1a497452feb58c471$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($abc197c7249b5d64e5aa6e6cd9d70e04$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($ace2570df1c8e5bdc1622423fba3afcb$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($a3230a2547d18894783fda977dc20f9c$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($e4e9d17d054a5b1571e266c27b0$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($b759cad58197b50c1b0a70079b90d0$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($e3c9619de0e391888b7af3687ae1ca$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($ffaa0058474a0c5af84ee42da22e89$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($eb97c66ca1aabe657d4d3d684a52745$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($df4355d3b8e7b4eb963b620181aa9fa$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($a8b7f12ad4f258ed52f42c8a1cb43c55$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($d4031e47e9461fd5df823a3a979d9c4$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($ad26b7a6c8ce1c4b03972527c0ef2d02$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($bba00e443e162220b2c6ec0ed425ca73$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($edcd0095126ee31dc5d095f17da37f97$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($c466527fca88404b3f0ca88f196536d0$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($cb8c52ec91eb32b51c9ed7b52e7b8a23$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($d833d3e73b516f5452ebb1ad0ac66f2$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($d0b18d4d94ae04ae7e6849f6a9d3061$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($c7f47492a7c0909c69e50b446c5fd9df$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($ba3d6fe17ecccf2b67f312467e19a2d$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($b813e91f8ab3c16586a3f3286c12409e$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($f64529017d6a25dd65cf5b4903bb42a4$exports).default
};

function $d9a9ec54ac1006cb2dd080cc05ab18c$var$ComboBox(props, ref) {
  props = useProviderProps(props);
  let isMobile = useIsMobileDevice();

  if (isMobile) {
    // menuTrigger=focus/manual don't apply to mobile combobox
    return /*#__PURE__*/_react.createElement($ba7df4b960ac8e701862298c225558$export$MobileComboBox, _babelRuntimeHelpersExtends({}, props, {
      menuTrigger: "input",
      ref: ref
    }));
  } else {
    return /*#__PURE__*/_react.createElement($d9a9ec54ac1006cb2dd080cc05ab18c$var$ComboBoxBase, _babelRuntimeHelpersExtends({}, props, {
      ref: ref
    }));
  }
}

const $d9a9ec54ac1006cb2dd080cc05ab18c$var$ComboBoxBase = /*#__PURE__*/_react.forwardRef(function ComboBoxBase(props, ref) {
  let {
    menuTrigger = 'input',
    shouldFlip = true,
    direction = 'bottom',
    isQuiet,
    loadingState,
    onLoadMore
  } = props;
  let formatMessage = useMessageFormatter($d9a9ec54ac1006cb2dd080cc05ab18c$var$intlMessages);
  let isAsync = loadingState != null;
  let popoverRef = useRef();
  let unwrappedPopoverRef = useUnwrapDOMRef(popoverRef);
  let buttonRef = useRef();
  let unwrappedButtonRef = useUnwrapDOMRef(buttonRef);
  let listBoxRef = useRef();
  let inputRef = useRef();
  let domRef = useFocusableRef(ref, inputRef);
  let {
    contains
  } = useFilter({
    sensitivity: 'base'
  });
  let state = useComboBoxState(_babelRuntimeHelpersExtends({}, props, {
    defaultFilter: contains,
    allowsEmptyCollection: isAsync
  }));
  let layout = useListBoxLayout(state);
  let {
    buttonProps,
    inputProps,
    listBoxProps,
    labelProps
  } = useComboBox(_babelRuntimeHelpersExtends({}, props, {
    keyboardDelegate: layout,
    buttonRef: unwrappedButtonRef,
    popoverRef: unwrappedPopoverRef,
    listBoxRef,
    inputRef: inputRef,
    menuTrigger
  }), state);
  let {
    overlayProps,
    placement,
    updatePosition
  } = useOverlayPosition({
    targetRef: unwrappedButtonRef,
    overlayRef: unwrappedPopoverRef,
    scrollRef: listBoxRef,
    placement: direction + " end",
    shouldFlip: shouldFlip,
    isOpen: state.isOpen,
    onClose: state.close
  }); // Measure the width of the inputfield and the button to inform the width of the menu (below).

  let [menuWidth, setMenuWidth] = useState(null);
  let {
    scale
  } = useProvider();
  let onResize = useCallback(() => {
    if (unwrappedButtonRef.current && inputRef.current) {
      let buttonWidth = unwrappedButtonRef.current.offsetWidth;
      let inputWidth = inputRef.current.offsetWidth;
      setMenuWidth(buttonWidth + inputWidth);
    }
  }, [unwrappedButtonRef, inputRef, setMenuWidth]);
  useResizeObserver({
    ref: domRef,
    onResize: onResize
  });
  useLayoutEffect(onResize, [scale, onResize]); // Update position once the ListBox has rendered. This ensures that
  // it flips properly when it doesn't fit in the available space.
  // TODO: add ResizeObserver to useOverlayPosition so we don't need this.

  useLayoutEffect(() => {
    if (state.isOpen) {
      requestAnimationFrame(() => {
        updatePosition();
      });
    }
  }, [state.isOpen, updatePosition]);

  let style = _babelRuntimeHelpersExtends({}, overlayProps.style, {
    width: isQuiet ? null : menuWidth,
    minWidth: isQuiet ? "calc(" + menuWidth + "px + calc(2 * var(--spectrum-dropdown-quiet-offset)))" : menuWidth
  });

  return /*#__PURE__*/_react.createElement(_react.Fragment, null, /*#__PURE__*/_react.createElement(Field, _babelRuntimeHelpersExtends({}, props, {
    labelProps: labelProps,
    ref: domRef
  }), /*#__PURE__*/_react.createElement($d9a9ec54ac1006cb2dd080cc05ab18c$var$ComboBoxInput, _babelRuntimeHelpersExtends({}, props, {
    isOpen: state.isOpen,
    loadingState: loadingState,
    inputProps: inputProps,
    inputRef: inputRef,
    triggerProps: buttonProps,
    triggerRef: buttonRef
  }))), /*#__PURE__*/_react.createElement(Popover, {
    isOpen: state.isOpen,
    UNSAFE_style: style,
    UNSAFE_className: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-popover', {
      'spectrum-InputGroup-popover--quiet': isQuiet
    }),
    ref: popoverRef,
    placement: placement,
    hideArrow: true,
    isNonModal: true,
    isDismissable: false
  }, /*#__PURE__*/_react.createElement(ListBoxBase, _babelRuntimeHelpersExtends({}, listBoxProps, {
    ref: listBoxRef,
    disallowEmptySelection: true,
    autoFocus: state.focusStrategy,
    shouldSelectOnPressUp: true,
    focusOnPointerEnter: true,
    layout: layout,
    state: state,
    shouldUseVirtualFocus: true,
    isLoading: loadingState === 'loadingMore',
    onLoadMore: onLoadMore,
    renderEmptyState: () => isAsync && /*#__PURE__*/_react.createElement("span", {
      className: classNames($e7ba5e7d00617a260ea1fc3d7c6f84$$interop$default, 'no-results')
    }, formatMessage('noResults'))
  })), /*#__PURE__*/_react.createElement(DismissButton, {
    onDismiss: () => state.close()
  })));
});

const $d9a9ec54ac1006cb2dd080cc05ab18c$var$ComboBoxInput = /*#__PURE__*/_react.forwardRef(function ComboBoxInput(props, ref) {
  let {
    isQuiet,
    isDisabled,
    isReadOnly,
    validationState,
    inputProps,
    inputRef,
    triggerProps,
    triggerRef,
    autoFocus,
    style,
    className,
    loadingState,
    isOpen,
    menuTrigger
  } = props;
  let {
    hoverProps,
    isHovered
  } = useHover({});
  let formatMessage = useMessageFormatter($d9a9ec54ac1006cb2dd080cc05ab18c$var$intlMessages);
  let timeout = useRef(null);
  let [showLoading, setShowLoading] = useState(false);

  let loadingCircle = /*#__PURE__*/_react.createElement(ProgressCircle, {
    "aria-label": formatMessage('loading'),
    size: "S",
    isIndeterminate: true,
    UNSAFE_className: classNames($d6ccebc39ce6c9807064e14b8824ec$$interop$default, 'spectrum-Textfield-circleLoader', classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-input-circleLoader'))
  });

  let isLoading = loadingState === 'loading' || loadingState === 'filtering';
  let inputValue = inputProps.value;
  let lastInputValue = useRef(inputValue);
  useEffect(() => {
    if (isLoading && !showLoading) {
      if (timeout.current === null) {
        timeout.current = setTimeout(() => {
          setShowLoading(true);
        }, 500);
      } // If user is typing, clear the timer and restart since it is a new request


      if (inputValue !== lastInputValue.current) {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
          setShowLoading(true);
        }, 500);
      }
    } else if (!isLoading) {
      // If loading is no longer happening, clear any timers and hide the loading circle
      setShowLoading(false);
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    lastInputValue.current = inputValue;
  }, [isLoading, showLoading, inputValue]);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    within: true,
    isTextInput: true,
    focusClass: classNames($da042374adac990dbdf960d689b813$$interop$default, 'is-focused'),
    focusRingClass: classNames($da042374adac990dbdf960d689b813$$interop$default, 'focus-ring'),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, hoverProps, {
    ref: ref,
    style: style,
    className: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup', {
      'spectrum-InputGroup--quiet': isQuiet,
      'is-disabled': isDisabled,
      'spectrum-InputGroup--invalid': validationState === 'invalid',
      'is-hovered': isHovered
    }, className)
  }), /*#__PURE__*/_react.createElement(TextFieldBase, {
    inputProps: inputProps,
    inputRef: inputRef,
    UNSAFE_className: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-field'),
    inputClassName: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-input'),
    validationIconClassName: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-InputGroup-input-validationIcon'),
    isDisabled: isDisabled,
    isQuiet: isQuiet,
    validationState: validationState // loading circle should only be displayed if menu is open, if menuTrigger is "manual", or first time load (to stop circle from showing up when user selects an option)
    // TODO: add special case for completionMode: complete as well
    ,
    isLoading: showLoading && (isOpen || menuTrigger === 'manual' || loadingState === 'loading'),
    loadingIndicator: loadingState != null && loadingCircle
  }), /*#__PURE__*/_react.createElement(PressResponder, {
    preventFocusOnPress: true,
    isPressed: isOpen
  }, /*#__PURE__*/_react.createElement(FieldButton, _babelRuntimeHelpersExtends({}, triggerProps, {
    ref: triggerRef,
    UNSAFE_className: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-FieldButton'),
    isDisabled: isDisabled || isReadOnly,
    isQuiet: isQuiet,
    validationState: validationState
  }), /*#__PURE__*/_react.createElement(_spectrumIconsUiChevronDownMedium, {
    UNSAFE_className: classNames($da042374adac990dbdf960d689b813$$interop$default, 'spectrum-Dropdown-chevron')
  })))));
});
/**
 * ComboBoxes combine a text entry with a picker menu, allowing users to filter longer lists to only the selections matching a query.
 */


const ComboBox = /*#__PURE__*/_react.forwardRef($d9a9ec54ac1006cb2dd080cc05ab18c$var$ComboBox);

exports.ComboBox = ComboBox;
